import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "index container"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "app-list"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = {
  class: "image flex justify-center items-center"
};
const _hoisted_7 = {
  class: "info"
};
const _hoisted_8 = {
  class: "info-title"
};
const _hoisted_9 = {
  class: "info-text"
};
const _hoisted_10 = {
  class: "btn"
};
const _hoisted_11 = {
  key: 0
};
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { checkSession, getSystemInfo } from "@/store/cache";
import { httpGet, httpPost } from "@/utils/http";
import { arrayContains, removeArrayItem, showLoginDialog, substr } from "@/utils/libs";
import { showNotify } from "vant";
import { ElMessage } from "element-plus";
export default {
  __name: 'Index',
  setup(__props) {
    const title = ref(process.env.VUE_APP_TITLE);
    const router = useRouter();
    const isLogin = ref(false);
    const apps = ref([]);
    const loading = ref(false);
    const roles = ref([]);
    const slogan = ref("你有多大想象力，AI就有多大创造力！");
    onMounted(() => {
      getSystemInfo().then(res => {
        title.value = res.data.title;
        if (res.data.slogan) {
          slogan.value = res.data.slogan;
        }
      }).catch(e => {
        ElMessage.error("获取系统配置失败：" + e.message);
      });
      checkSession().then(user => {
        isLogin.value = true;
        roles.value = user.chat_roles;
      }).catch(() => {});
      fetchApps();
    });
    const fetchApps = () => {
      httpGet("/app/list").then(res => {
        const items = res.data;
        // 处理 hello message
        for (let i = 0; i < items.length; i++) {
          items[i].intro = substr(items[i].hello_msg, 80);
        }
        apps.value = items;
      }).catch(e => {
        showNotify({
          type: "danger",
          message: "获取应用失败：" + e.message
        });
      });
    };
    const updateRole = (row, opt) => {
      if (!isLogin.value) {
        return showLoginDialog(router);
      }
      const title = ref("");
      if (opt === "add") {
        title.value = "添加应用";
        const exists = arrayContains(roles.value, row.key);
        if (exists) {
          return;
        }
        roles.value.push(row.key);
      } else {
        title.value = "移除应用";
        const exists = arrayContains(roles.value, row.key);
        if (!exists) {
          return;
        }
        roles.value = removeArrayItem(roles.value, row.key);
      }
      httpPost("/role/update", {
        keys: roles.value
      }).then(() => {
        ElMessage.success({
          message: title.value + "成功！",
          duration: 1000
        });
      }).catch(e => {
        ElMessage.error(title.value + "失败：" + e.message);
      });
    };
    const hasRole = roleKey => {
      return arrayContains(roles.value, roleKey, (v1, v2) => v1 === v2);
    };
    const useRole = roleId => {
      if (!isLogin.value) {
        return showLoginDialog(router);
      }
      router.push(`/mobile/chat/session?role_id=${roleId}`);
    };
    return (_ctx, _cache) => {
      const _component_van_notice_bar = _resolveComponent("van-notice-bar");
      const _component_van_grid_item = _resolveComponent("van-grid-item");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_grid = _resolveComponent("van-grid");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h2", _hoisted_2, _toDisplayString(title.value), 1), _createVNode(_component_van_notice_bar, {
        "left-icon": "info-o",
        scrollable: true
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(slogan.value) + "}", 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_grid, {
        "column-num": 3,
        gutter: 10,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_grid_item, {
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('chat'))
        }, {
          icon: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("i", {
            class: "iconfont icon-chat"
          }, null, -1)])),
          text: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("div", {
            class: "text"
          }, "AI 对话", -1)])),
          _: 1
        }), _createVNode(_component_van_grid_item, {
          onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('image'))
        }, {
          icon: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("i", {
            class: "iconfont icon-mj"
          }, null, -1)])),
          text: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("div", {
            class: "text"
          }, "AI 绘画", -1)])),
          _: 1
        }), _createVNode(_component_van_grid_item, {
          onClick: _cache[2] || (_cache[2] = $event => _unref(router).push('imgWall'))
        }, {
          icon: _withCtx(() => [_createVNode(_component_van_icon, {
            name: "photo-o"
          })]),
          text: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("div", {
            class: "text"
          }, "AI 画廊", -1)])),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_list, {
        loading: loading.value,
        "onUpdate:loading": _cache[3] || (_cache[3] = $event => loading.value = $event),
        finished: true,
        "finished-text": "",
        onLoad: fetchApps
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apps.value, item => {
          return _openBlock(), _createBlock(_component_van_cell, {
            key: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_image, {
              src: item.icon
            }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(item.hello_msg), 1)])]), _createElementVNode("div", _hoisted_10, [hasRole(item.key) ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_button, {
              size: "small",
              type: "success",
              onClick: $event => useRole(item.id)
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("使用")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_van_button, {
              size: "small",
              type: "danger",
              onClick: $event => updateRole(item, 'remove')
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("移除")])),
              _: 2
            }, 1032, ["onClick"])])) : (_openBlock(), _createBlock(_component_van_button, {
              key: 1,
              size: "small",
              style: {
                "--el-color-primary": "#009999"
              },
              onClick: $event => updateRole(item, 'add')
            }, {
              default: _withCtx(() => [_createVNode(_component_van_icon, {
                name: "add-o"
              }), _cache[11] || (_cache[11] = _createElementVNode("span", null, "添加应用", -1))]),
              _: 2
            }, 1032, ["onClick"]))])])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["loading"])])])]);
    };
  }
};